module.exports = __webpack_public_path__ + "media/images/pic/brodno/gallery/2020/pygmalion/thumbs/2-dd38c1abfc7eec287b8181e18577b69f.webp";